export default function HeroHeading({ titleA, titleB, titleC, eyebrow }) {
  return (
    <>
      <span className="label-eyebrow flex items-center gap-2">
        <span className="inline-block w-8 h-px bg-[var(--accent)]" />
        {eyebrow}
      </span>
      <h1 className="font-heading text-[44px] sm:text-[68px] lg:text-[84px] leading-[0.95] mt-5">
        {titleA}{" "}
        <span className="relative inline-block">
          <span className="relative z-10">{titleB}</span>
          <svg
            className="absolute -bottom-2 left-0 w-full"
            viewBox="0 0 200 14"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M2 9C40 4 80 2 198 7"
              stroke="#E05A33"
              strokeWidth="5"
              strokeLinecap="round"
            />
          </svg>
        </span>
        <br />
        {titleC}
      </h1>
    </>
  );
}
